export default {
  en: {
    chart: 'Pie chart',
    total: 'Total',
  },
};
